export const Primary = '#000'

export const Secondary = '#292F36'

export const White = '#F7FFF7'

export const Accent = '#00FFC5'

export const SecondaryAccent = '#1B2A41'
